module.exports = __webpack_public_path__ + "media/src/assets/Images/Door-e02ae8f5c00882817081370f65a585c4.svg";